import React, { MouseEvent, ReactElement } from 'react';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { ROUTES } from 'b2b-apps/shop/routes/components/Router';
import { useRouterPush, useUrlCreator } from 'b2b-apps/shop/routes/hooks';
import { EnhancedComponentProps, EnhancedComponentType, InjectedProps, WrappedComponentType } from './';

const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const t = useTranslate();
    const {
      manufacturerInternalPage,
      ...originalProps
    } = props;
    const { manufacturerWarranty } = props;
    const pushAction = useRouterPush();
    const urlCreator = useUrlCreator();
    const manufacturerPageUrl = `${urlCreator(
      ROUTES.manufacturer,
      { manufacturer: manufacturerInternalPage.replace('/', '') },
    )}`;

    const handleManufacturerPageClick = (event: MouseEvent<HTMLAnchorElement>): void => {
      event.preventDefault();
      pushAction(manufacturerPageUrl);
    };

    const text = {
      sku: t('SKU'),
      manufacturerProductId: t('Manufacturer Product ID'),
      manufacturerPage: t('Manufacturer page'),
      manufacturerLink: t('Manufacturer link'),
      manufacturerWarranty: t('Manufacturer warranty'),
      manufacturerWarrantyMonthsZero: t('0 months'),
      manufacturerWarrantyMonths: t(['month', '{n} months', 'n'], {
        n: manufacturerWarranty,
      }),
      soldSince: t('Sold since'),
      ean: t('EAN'),
      stock: t('Stock'),
    };


    const injectedProps: InjectedProps = {
      onManufacturerPageClick: handleManufacturerPageClick,
      manufacturerPageUrl,
      text,
    };

    return <Component {...originalProps} {...injectedProps} />;
  };

  return WithContainer;
};

export { withContainer };
